<template>
    <div ref="container" class="time-picker">
        <div class="input-group">
            <input
                ref="input"
                type="text"
                class="form-control"
                :disabled="disabled"
                :maxlength="8"
                :value="modelValue"
                autocomplete="off"
            />

            <div class="input-group-addon input-group-append">
                <div class="input-group-text">
                    <i class="fa fa-clock"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./MeetingTimePicker.ts"></script>
<style src="../TimePicker/TimePicker.scss"></style>
